type TemplatePaneMode = "view" | "edit";

function toQuery(params: URLSearchParams): string {
  const query = params.toString();
  return query ? `?${query}` : "";
}

function applyDeletedParam(params: URLSearchParams, deleted: string | null | undefined): void {
  if (deleted === "true" || deleted === "1") {
    params.set("showDeleted", "1");
  }
}

export function buildTemplateConfigurationPath(
  orgId: string,
  baseParams?: URLSearchParams,
): string {
  const params = new URLSearchParams();
  applyDeletedParam(params, baseParams?.get("deleted") ?? baseParams?.get("showDeleted"));
  return `/o/${orgId}/configuration/encounter-types${toQuery(params)}`;
}

export function buildDocumentTemplatePanePath(
  orgId: string,
  templateId: string,
  mode: TemplatePaneMode = "view",
  baseParams?: URLSearchParams,
): string {
  const params = new URLSearchParams();
  params.set("documentId", templateId);
  params.set("documentMode", mode);
  params.set("documents", "all");
  applyDeletedParam(params, baseParams?.get("deleted") ?? baseParams?.get("showDeleted"));
  return `/o/${orgId}/configuration/encounter-types?${params.toString()}`;
}

export function buildDocumentTemplateCreatePanePath(
  orgId: string,
  schemaId?: string | null,
  baseParams?: URLSearchParams,
): string {
  const params = new URLSearchParams();
  params.set("editor", "new-document");
  params.set("documents", "all");
  if (schemaId) {
    params.set("schema_id", schemaId);
  }
  applyDeletedParam(params, baseParams?.get("deleted") ?? baseParams?.get("showDeleted"));
  return `/o/${orgId}/configuration/encounter-types?${params.toString()}`;
}

export function buildEncounterSchemaPanePath(
  orgId: string,
  schemaId: string,
  baseParams?: URLSearchParams,
): string {
  const params = new URLSearchParams();
  params.set("selected", schemaId);
  params.set("editor", "edit");
  applyDeletedParam(params, baseParams?.get("deleted") ?? baseParams?.get("showDeleted"));
  return `/o/${orgId}/configuration/encounter-types?${params.toString()}`;
}

export function buildEncounterSchemaCreatePanePath(
  orgId: string,
  options: {
    createMode?: string | null;
    importedTemplateSeriesId?: string | null;
  } = {},
  baseParams?: URLSearchParams,
): string {
  const params = new URLSearchParams();
  params.set("editor", "new");
  if (options.createMode) {
    params.set("create_mode", options.createMode);
  }
  if (options.importedTemplateSeriesId) {
    params.set("imported_template_series_id", options.importedTemplateSeriesId);
  }
  applyDeletedParam(params, baseParams?.get("deleted") ?? baseParams?.get("showDeleted"));
  return `/o/${orgId}/configuration/encounter-types?${params.toString()}`;
}
